import { render, staticRenderFns } from "./ProjectJournalsT.vue?vue&type=template&id=3731cd05&scoped=true&"
import script from "./ProjectJournalsT.vue?vue&type=script&lang=ts&"
export * from "./ProjectJournalsT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectJournalsT.vue?vue&type=style&index=0&id=3731cd05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731cd05",
  null
  
)

export default component.exports